import type { IncomeSplitConfigCreatedVia } from '@fruitful/income-split';
import type { MoneyMapWithRulesAndAccounts } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface CurrentIncomeSplitSnapshot {
    id: string;
    moneyMapId: string | null;
    status: string;
    createdVia: IncomeSplitConfigCreatedVia | null;
}

export interface ActiveMoneyMapWithIncomeSplit {
    moneyMap: MoneyMapWithRulesAndAccounts | null;
    currentIncomeSplit: CurrentIncomeSplitSnapshot | null;
    liveSplitMoneyMap: MoneyMapWithRulesAndAccounts | null;
}

export const getActiveMoneyMapWithIncomeSplitQueryKey =
    'getActiveMoneyMapWithIncomeSplit';

export const useGetActiveMoneyMapWithIncomeSplit =
    requestBuilder.query<ActiveMoneyMapWithIncomeSplit>({
        endpoint: '/api/money-map/active-with-income-split',
        queryKey: getActiveMoneyMapWithIncomeSplitQueryKey,
    });
